import { Helmet, HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Loader from './components/Loader/Loader';
import ResponsiveProvider from './context/ResponsiveContext';
import GlobalStyle from './GlobalStyle';
import useInit from './hooks/useInit';
import { AppRouter } from './routes/AppRoutes';
import mainTheme from './themes/mainTheme';

const App = () => {
  const { customerConfig, isConfigLoading, errorCode, isIE } = useInit();

  const { metaTags, calculatorThemeDto } = customerConfig;

  if (isIE) {
    return (
      <p>Sorry, but we don&apos;t support Internet Explorer. Please try with other browser.</p>
    );
  }

  if (isConfigLoading) {
    return <Loader />;
  }

  return (
    <ResponsiveProvider>
      <ThemeProvider theme={{ ...mainTheme, ...calculatorThemeDto }}>
        {metaTags && (
          <HelmetProvider>
            <Helmet>
              <meta charSet="utf-8" />
              <title>{metaTags.metaTitle}</title>
              <meta name="description" content={metaTags.metaDescription} />
              <link rel="icon" type="image/png" href={metaTags.faviconUrl} sizes="16x16" />
            </Helmet>
          </HelmetProvider>
        )}

        <GlobalStyle />
        <RouterProvider router={AppRouter({ config: customerConfig, errorCode })} />
      </ThemeProvider>
    </ResponsiveProvider>
  );
};

export default App;
